export const FETCH_SETTINGS_INBOXES_OPTIONS_REQUEST = 'FETCH_SETTINGS_INBOXES_OPTIONS_REQUEST',
      SETTINGS_INBOXES_ON_TOGGLE = 'SETTINGS_INBOXES_ON_TOGGLE',
      SETTINGS_INBOXES_SAVE_PREPARE = 'SETTINGS_INBOXES_SAVE_PREPARE',
      SETTINGS_INBOXES_SAVE_REQUEST = 'SETTINGS_INBOXES_SAVE_REQUEST'
